es-table-virtualized {
    display: block;
    width: 100%;
    contain: content;
}

es-table-virtualized,
    es-table-virtualized * {
        box-sizing: border-box;
    }

:where([role='table']) {
    display: grid;
    position: relative;
    width: 100%;
    transform: translate3d(0, 0, 0);
}

:where([role='row']) {
    background-color: transparent;
    display: contents;
}

:where(a[role='row']) {
    color: inherit;
    text-decoration: inherit;
    transition: color 500ms ease;
}

:where(a[role='row']):hover {
        color: var(--color-secondary);
    }

:where([role='columnheader']:not(es-button), [role='cell']) {
    padding: 16px 12px;
    min-height: 50px;
}

:where([role='columnheader']:not(es-button), [role='cell']):first-child {
        padding-left: 24px;
    }

:where([role='columnheader']:not(es-button), [role='cell']):last-child {
        padding-right: 24px;
    }

.no_pad:where([role='columnheader']:not(es-button), [role='cell']) {
        padding: 0;
    }

.center:where([role='columnheader']:not(es-button), [role='cell']) {
        justify-content: center;
    }

.end:where([role='columnheader']:not(es-button), [role='cell']) {
        justify-content: flex-end;
    }

.group_first:where([role='columnheader']:not(es-button), [role='cell']) {
        padding-left: 20px;
    }

.group_last:where([role='columnheader']:not(es-button), [role='cell']) {
        padding-right: 20px;
    }

:where([role='columnheader']) {
    display: flex;
    align-items: center;
    text-align: left;
    font-weight: 700;
    font-size: 16px;

    height: auto;
    min-height: 52px;
    color: var(--color-title-2);
    line-height: 1;

    border-color: var(--color-shade-30);
    border-style: solid;
    border-width: 0;
    border-bottom-width: 2px;
}

.expander-header:where([role='columnheader']) {
        padding-left: 0;
    }

.expander-header:where([role='columnheader']) + *[role='columnheader'] {
            padding-left: 0;
        }

.group_first:where([role='columnheader']) {
        border-left-width: 2px;
    }

:where(es-button[role='columnheader']) {
    --primary-color: var(--color-title-2);
    --spacing: 2px;
    --align-inner: flex-start;

    line-height: 1;
    outline-offset: -6px;
}

:where(es-button[role='columnheader'])::part(button) {
        padding: 14px 12px;
    }

:where(es-button[role='columnheader']):first-child::part(button) {
        padding-left: 24px;
    }

:where(es-button[role='columnheader']):last-child::part(button) {
        padding-right: 24px;
    }

.no_pad:where(es-button[role='columnheader'])::part(button) {
        padding: 0;
    }

.center:where(es-button[role='columnheader']) {
        --align-inner: center;
    }

.end:where(es-button[role='columnheader']) {
        --align-inner: flex-end;
    }

.group_first:where(es-button[role='columnheader'])::part(button) {
        border-left-width: 2px;
        padding-left: 20px;
    }

.group_last:where(es-button[role='columnheader'])::part(button) {
        padding-right: 20px;
    }

:where(.subheader [role='columnheader']) {
    font-weight: 400;
}

.sticky [role='columnheader'] {
    position: sticky;
    top: 0;
    top: var(--sticky-top, 0);
    z-index: 1;
    background-color: var(--color-background);
    transform: translate3d(0, 0, 0);
}

.subheader.sticky [role='columnheader'] {
    top: calc(0px + 52px);
    top: calc(var(--sticky-top, 0px) + 52px);
}

:where([role='rowgroup']) {
    display: contents;

    --row-color: var(--color-background);
    --border-top-color: var(--border-top-color, transparent);
    --border-bottom-color: var(--border-bottom-color, transparent);
    --border-group-color: var(--color-shade-30);
}

.highlight:where([role='rowgroup']) [role='cell'] {
        z-index: 0;
    }

.highlight:where([role='rowgroup']) [role='cell']::after {
            position: absolute;
            content: '';
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            display: block;
            animation-iteration-count: 2;
            animation-duration: 1s;
            animation-name: es-table-jump-highlight;
            z-index: -1;
            opacity: 0.2;
        }

:where(es-table, es-table-virtualized)[high-contrast]
    :where([role='rowgroup']) {
    --border-bottom-color: var(--color-shade-30);
}

:where(es-table, es-table-virtualized):not([high-contrast]) .odd {
    --row-color: var(--color-shade-10);
}

:where(.selectable) {
    cursor: pointer;
    transition: color 500ms ease;
}

:where(.selectable) [role='cell']:first-child::before {
        content: '';
        display: block;
        position: absolute;
        background-color: currentColor;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        right: 100%;
        top: 0;
        bottom: 0;
        margin: auto;
        transition:
            transform 500ms ease, opacity 500ms ease;
        opacity: 0;
    }

:where(.selectable) [role='cell']:focus-visible::before {
        transform: translateX(5px);
        opacity: 0.5;
    }

:where(.selectable):hover,
    :where(.selectable):focus {
        color: var(--color-secondary);
    }

:where(.selectable):hover [role='cell']:first-child::before, :where(.selectable):focus [role='cell']:first-child::before {
            transform: translateX(5px);
            opacity: 0.5;
        }

:where(.selected) {
    color: var(--color-secondary);
}

:where(.selected):hover [role='cell']:focus-visible::before,
        :where(.selected):focus [role='cell']:focus-visible::before,
        :where(.selected) [role='cell']:focus-visible::before,
        :where(.selected):hover [role='cell']:first-child::before,
        :where(.selected):focus [role='cell']:first-child::before,
        :where(.selected) [role='cell']:first-child::before {
            transform: translateX(10px);
            opacity: 1;
        }

:where([role='cell']) {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    background-color: var(--row-color);
    border-top: 1px solid var(--border-top-color);
    border-bottom: 1px solid var(--border-bottom-color);
}

:where([role='cell']):where(:focus, :focus ~ [role='cell']) {
        color: var(--color-secondary);
    }

.focusCell:where([role='cell']) {
        outline: none;
    }

.borderless:where([role='cell']) {
        border-top: 1px solid transparent;
        border-bottom: 1px solid transparent;
    }

.full_width:where([role='cell']) {
        grid-column: 1 / -1;
    }

.group_first:where([role='cell']) {
        border-left: 2px solid var(--border-group-color);
        padding-left: 20px;
    }

.group_last:where([role='cell']) {
        padding-right: 20px;
    }

:where([role='details']) {
    display: flex;
    align-items: center;
    grid-column: 1/-1;
    padding: 14px 24px 14px 50px;
    min-height: 50px;
    border-bottom: 1px solid var(--color-shade-30);
}

@keyframes es-table-jump-highlight {
    from {
        background-color: transparent;
    }

    50% {
        background-color: var(--color-warning);
    }

    to {
        background-color: transparent;
    }
}


.before {
    grid-row: before;
    grid-column-start: 1;
    grid-column-end: -1;
}

.after {
    grid-row: after;
    grid-column-start: 1;
    grid-column-end: -1;
}
